module.exports = __webpack_public_path__ + "media/promotional/ulm-2024a04f.jpeg";